import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { DepertmentService } from 'app/services/models/depertment.service';
import { PersonService } from 'app/services/models/person.service';
import { ProjectService } from 'app/services/models/project.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';
import { DepertmantDialogComponent } from '../depertmant-dialog/depertmant-dialog.component';
import { MissionService } from 'app/services/models/mission.service';
import { MissionDialogComponent } from '../mission-dialog/mission-dialog.component';

@Component({
  selector: 'app-create-worker-dialog',
  templateUrl: './create-worker-dialog.component.html',
  styleUrls: ['./create-worker-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateWorkerDialogComponent implements OnInit {
  personForm: FormGroup;
  selectedProjects: any[] = [];
  depertmants: any[] = [];
  missions: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private personService: PersonService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private router: Router,
    private projectService: ProjectService,
    public authService: AuthService,
    private depertmantSerivce: DepertmentService,
    private modalService: NgbModal,
    private missionService:MissionService
  ) { }

  date = new Date();
  projects: any[];
  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: false, // Saat kapalı
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: false, // Saat kapalı
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultDate: null // Bunu açıkça belirt
  };

  public dateTimeLeaveJobOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: false, // Saat kapalı
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
    defaultDate: null // Bunu açıkça belirt
  };

  async ngOnInit() {
    this.personForm = this.fb.group({
      name: [null, Validators.required],
      lastName: [null, Validators.required],
      mission: [null],
      phoneNumber: [null],
      mail: [null],
      address: [null],
      birthDay: [null],
      startDate: [null],
      workingStatus: [true],
      department: [null],
      emergencyContact: [null],
      tc: [null, [Validators.maxLength(11)]],
      wage: [0, Validators.min(0)],
      leaveJob: [null],
      workingDays: [null],
      registrationNumber: [null],
      depertmantId:[null],
      missionId:[null],
      projects: [[], this.authService.isEndpointStatus('POST.Writing.CreatePersonProjects') ? [Validators.required] : []] // burada seçili projeler tutulacak
    });
    await this.getAllProject('');
    await this.getAllDepertmant();
    await this.getAllMission();
  }

  days = [
    { name: 'Monday', label: 'Pazartesi', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Tuesday', label: 'Salı', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Wednesday', label: 'Çarşamba', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Thursday', label: 'Perşembe', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Friday', label: 'Cuma', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Saturday', label: 'Cumartesi', selected: false, startTime: { hour: 10, minute: 0 }, endTime: { hour: 16, minute: 0 } },
    { name: 'Sunday', label: 'Pazar', selected: false, startTime: { hour: 10, minute: 0 }, endTime: { hour: 16, minute: 0 } },
  ];

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    if (this.personForm.valid) {
      // Geçersiz ya da boşsa null yap
      const birthDay = this.personForm.value.birthDay;
      const startDate = this.personForm.value.startDate;
      const leaveJob = this.personForm.value.leaveJob;

      const isInvalid = (val: any) =>
        !val || val === '' || new Date(val).toString() === 'Invalid Date' || new Date(val).getTime() === 0;

      if (isInvalid(birthDay)) {
        this.personForm.patchValue({ birthDay: null });
      }
      if (isInvalid(startDate)) {
        this.personForm.patchValue({ startDate: null });
      }
      if (isInvalid(leaveJob)) {
        this.personForm.patchValue({ leaveJob: null });
      }

      console.log(this.personForm.value);

      const selectedDays = this.days
        .filter((day) => day.selected)
        .map((day) => ({
          Day: day.name,
          start: `${day.startTime.hour.toString().padStart(2, '0')}:${day.startTime.minute.toString().padStart(2, '0')}`,
          end: `${day.endTime.hour.toString().padStart(2, '0')}:${day.endTime.minute.toString().padStart(2, '0')}`,
        }));

      const response = await this.personService.createWorker(this.personForm.value, selectedDays);

      if (response.status == true) {
        this.toastrService.success(response.message);
        this.personService.sendEvent(true);
        this.closeModal();
      } else {
        this.toastrService.error(response.message);
      }
    }
  }

  applyToAll() {
    const firstDay = this.days[0];
    if (!firstDay.selected) {
      return;
    }

    const startTime = firstDay.startTime;
    const endTime = firstDay.endTime;

    this.days.forEach((day, index) => {
      if (index !== 0 && day.selected) {
        day.startTime = { ...startTime };
        day.endTime = { ...endTime };
      }
    });
  }

  async onProjectSearch(searchTerm: any) {
    console.log(searchTerm.term);
    if (!searchTerm || searchTerm.length < 1) {
      this.projects = [];
      return;
    }
    await this.getAllProject(searchTerm.term);
  }

  async getAllProject(search) {
    const data = await this.projectService.getAllProject(0, 10, '', 1);
    console.log(data);
    this.projects = data.projects.map(p => ({
      ...p,
      isVisible: true // varsayılan görünür
    }));
  }

  onProjectChange(selected: any[]) {
    this.selectedProjects = selected.map(p => {
      const existing = this.selectedProjects.find(sp => sp.id === p.id);
      return {
        ...p,
        isVisible: existing ? existing.isVisible : true
      };
    });
    this.personForm.patchValue({
      projects: this.selectedProjects
    });
  }


  toggleProjectVisibility(project: any, isVisible: boolean) {
    project.isVisible = isVisible;

    // FormControl içindeki array’i güncelle
    const currentProjects = this.personForm.get('projects')?.value || [];
    const index = currentProjects.findIndex(p => p.id === project.id);
    if (index > -1) {
      currentProjects[index] = { ...project }; // güncellenmiş obje
      this.personForm.get('projects')?.setValue(currentProjects);
    }
  }

  async getAllDepertmant() {
    const data = await this.depertmantSerivce.getAllDepertmant();
    this.depertmants = data;
  }

  async showCreateDepartmanDialog() {
    const modal = this.modalService.open(DepertmantDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.result.then(async (result) => {
      if (result == true) {
        await this.getAllDepertmant();
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);
    });
  }

  async getAllMission() {
    const data = await this.missionService.getAllMission();
    this.missions = data;
  }

  async showCreateMissionDialog() {
    const modal = this.modalService.open(MissionDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.result.then(async (result) => {
      if (result == true) {
        await this.getAllMission();
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);
    });
  }
}